import React, { useContext } from "react"
import DescargaPdfPw from "../descargaPdfPw"

const BlogDescargaPdfPw = ({ content }) => {
  const newContent = {
    ...content,
  }
  newContent.data.showInMobile = true
  newContent.data.isCentered = true

  return <DescargaPdfPw content={newContent} />
}

export default BlogDescargaPdfPw
